import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import {
  SIGNED_TIMETABLES_REPOSITORY,
  SignedTimetablesRepository
} from '@app/domain/repositories/mot/signed-timetables.repository.contract';
import { SignedTimetable } from '@app/entities/models/mot/signed-timetables/signed-timetables.model';
import { MSafeAny } from '@app/shared/models/safe-any/safe-any.model';

import { SignedTimetablesUseCases } from './signed-timetables.use-cases.contract';

@Injectable({
  providedIn: 'root'
})
export class SignedTimetablesUseCasesImpl implements SignedTimetablesUseCases {
  #signedTimetablesRepository: SignedTimetablesRepository = inject(SIGNED_TIMETABLES_REPOSITORY);
  onError$ = this.#signedTimetablesRepository.onError$;

  getSignedTimetables(): Observable<SignedTimetable[]> {
    return this.#signedTimetablesRepository.getSignedTimetables();
  }

  getSignedTimetableByDocumentId(documentId: string): Observable<MSafeAny> {
    return this.#signedTimetablesRepository.getSignedTimetableByDocumentId(documentId);
  }
}
